import React, { useContext } from 'react';
import { FlexMiddle } from '../../Flex';
import ConfigContext from '../../../contexts/ConfigContext';

const HelpDeskCategoriesChip = ({ value }) => {
  const { t } = useContext(ConfigContext);
  if (!value) return null;
  if (Array.isArray(value)) {
    if (!value.length) return null;
    if (value.length === 1) {
      const single = value[0];
      const categoryName = single?.categoryName ?? String(single?.categoryId || single);
      const branchName = single?.branchName;
      const displaySingle = branchName ? `${branchName} · ${categoryName}` : categoryName;
      return <FlexMiddle>{displaySingle}</FlexMiddle>;
    }
    return <FlexMiddle>{t('help_desk_n_categories', { count: value.length })}</FlexMiddle>;
  }
  const categoryName = value?.categoryName ?? String(value?.categoryId || value);
  const branchName = value?.branchName;
  const display = branchName ? `${branchName} · ${categoryName}` : categoryName;
  return <FlexMiddle>{display}</FlexMiddle>;
};

export default HelpDeskCategoriesChip;
